<template>
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.875 3.5V8.75H6.125"
      stroke="#404A57"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.5 6.125V11.375L14 13.125"
      stroke="#404A57"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.07125 13.125C3.63859 14.7353 4.71392 16.1177 6.1352 17.0637C7.55648 18.0098 9.24672 18.4683 10.9513 18.3702C12.6558 18.2721 14.2823 17.6227 15.5856 16.5198C16.889 15.4169 17.7986 13.9204 18.1774 12.2556C18.5563 10.5908 18.3838 8.84798 17.686 7.28973C16.9883 5.73148 15.803 4.44221 14.3087 3.61619C12.8145 2.79016 11.0923 2.47212 9.40159 2.70999C7.7109 2.94786 6.1433 3.72876 4.935 4.93502L0.875 8.75002"
      stroke="#404A57"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "IconAudit",
};
</script>

<style></style>
